import React, { useState} from 'react'
import _ from 'lodash'
import {PricingListTableHeaders} from "./PricingListTableHeaders";
import {PricingListRow} from "./PricingListRow";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandCircleDownSharpIcon from '@mui/icons-material/ExpandCircleDownSharp';

import './PricingListPage.scss'

import {headerHeight} from "./PricingListPage";
import {usePricingsStore} from "../../stores/pricingsStore";
import {useParams} from "react-router";
import {useUserContext} from "../../contexts/UserContext";

const TOTAL_COLUMNS = 10

const TableCells = ( { times, style, className } ) => {
    return _.times(times, (n) =>
        <td
            style={style}
            key={n}
            className={className}
        />
    )
}

export const PricingListPricing = ( { pricing, trim, style_description} ) => {
    return (
        <tr>
            <TableCells times={TOTAL_COLUMNS - 8}/>
            <PricingListRow
                pricing={pricing}
                trim={trim}
                style_description={style_description}
            />
        </tr>
    )
}

const PricingListTrim = ( { year, trim, collapsed, style_description } ) => {
    const renderPricings = () => _.map(trim.pricings, (pricing) => {
        return (
            <PricingListPricing
                key={pricing.id}
                pricing={pricing}
                trim={trim}
                year={year}
            />
        )
    })

    if (collapsed) return null;

    return (
        <React.Fragment>
            <tr>
                <TableCells times={TOTAL_COLUMNS - 8}/>
                <td className={'trim-sd-name'}>
                    <div className={'trim-name'}>{trim.name}</div>
                </td>
                <PricingListRow trim={trim}/>
            </tr>
            { renderPricings() }
        </React.Fragment>
    )
}

const PricingListModel = ( { year, modelName, trims, collapsed, shouldExpand } ) => {
    const search = usePricingsStore((state) => state.search)
    const [modelCollpased, setModelCollapsed] = useState(!shouldExpand)

    const renderTrims = () => {
        return (
            _.map(trims, (trim) => {
                return (
                    <PricingListTrim
                        key={trim.id}
                        trim={trim}
                        collapsed={modelCollpased && !Boolean(search.length)}
                        year={year}
                    />
                )
            })
        )
    }
    if (collapsed) return null;

    return (
        <React.Fragment>
            <tr>
                <TableCells times={TOTAL_COLUMNS - 9}/>
                    <td className={'PricingListTable-model_name'}>
                        <div className={'PricingListTable-model_name-button'} onClick={() => setModelCollapsed(!modelCollpased)}>
                            {
                                modelCollpased ?
                                    <ExpandMoreIcon
                                        className={'ExpandMoreIcon'}
                                        onClick={() => setModelCollapsed(!modelCollpased)}
                                    /> :
                                    <ExpandCircleDownSharpIcon
                                        className={'ExpandCircleUpSharpIcon'}
                                        onClick={() => setModelCollapsed(!modelCollpased)}
                                    />
                            }
                            {modelName}
                        </div>
                    </td>
                <TableCells times={TOTAL_COLUMNS - 2}/>
            </tr>
            { renderTrims() }
        </React.Fragment>
    )
}

const PricingListYear = ( { year, models, hasPricing } ) => {
    const { profileState } = useUserContext()
    const search = usePricingsStore((state) => state.search)
    const shouldExpand = Boolean(hasPricing && profileState?.is_pricing_expanded);
    const [yearCollpased, setYearCollapsed] = useState(!shouldExpand)

    const hasPricings = (trims) => {
        if (Array.isArray(trims)) {
            return trims.some(trim => trim.pricings.length)
        }
        return false
    }

    const renderModels = () => {
        return (
            _.map(models, (trims, model_name) => {
                        return <PricingListModel
                            key={model_name}
                            year={year}
                            shouldExpand={hasPricings(trims) && profileState?.is_pricing_expanded}
                            modelName={model_name}
                            trims={trims}
                            collapsed={yearCollpased && !Boolean(search.length)}
                        />
                    }
                )
        )
    }

    return (
        <React.Fragment>
            <tr>
                <td
                    style={{top: `${headerHeight}px`}}
                    className={'sticky-year-td'}
                >
                    <div className={'PricingListTable-year_name-button'}>
                        {
                            yearCollpased ?
                                <ExpandMoreIcon
                                    className={'ExpandMoreIcon'}
                                    onClick={() => setYearCollapsed(!yearCollpased)}
                                /> :
                                <ExpandCircleDownSharpIcon
                                    onClick={() => setYearCollapsed(!yearCollpased)}
                                    className={'ExpandCircleUpSharpIcon'}
                                />
                        }
                        {year}
                    </div>
                </td>
                <TableCells
                    style={{top: `${headerHeight}px`}}
                    times={TOTAL_COLUMNS - 1}
                    className={'sticky-year-td'}
                />
            </tr>
            { renderModels() }
        </React.Fragment>
    )
}

export const PricingListTable = ( { pricingData, headerHeight } ) => {
    const params = useParams();
    const make = params.make

    const renderYears = () => {
        return (
            _.map(pricingData, (models, year) => {
                const hasPricings = models.__has_pricings
                delete models.__has_pricings
                return (
                    <PricingListYear
                        key={`${year}-${make}`}
                        year={year}
                        models={models}
                        hasPricing={hasPricings}
                    />
                )
            })
        )
    }

    return (
        <React.Fragment>
            <table>
                <PricingListTableHeaders headerHeight={headerHeight} />
                <tbody>
                    {
                        renderYears()
                    }
                </tbody>
            </table>
        </React.Fragment>
    )
}